import React, { useMemo } from 'react';
import Lightbox, { GenericSlide, Slide, ViewCallbackProps } from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

type URL = string;

interface ReusableLightboxProps {
  isOpen: boolean;
  onClose: () => void;
  image?: URL;
  images?: URL[];
  initialIndex?: number;
  onIndexChange?: (index: number) => void;
}

interface ImageSlide {
  src: string;
}

const ReusableLightbox = ({
  isOpen,
  onClose,
  image,
  images,
  initialIndex = 0,
  onIndexChange,
}: ReusableLightboxProps) => {
  const slides: Slide[] = useMemo((): Slide[] => {
    if (images && images.length > 0) {
      return images.map((img: string): Slide => {
        const videoExtensions = ['mp4', 'webm', 'mov'];
        //get file extension
        const extension = img.split('.').pop()?.toLowerCase();
        if(extension && videoExtensions.includes(extension)) {
          return { sources: [{src: img, type: ''}], type: 'video' };
        }

        return { src: img }
      });
    } else if (image) {
      return [{ src: image }];
    }
    return [];
  }, [image, images]);

  if (!isOpen || slides.length === 0) {
    return null;
  }

  const isSingleImage: boolean = slides.length === 1;

  return (
    <Lightbox
      open={isOpen}
      close={onClose}
      slides={slides}
      index={initialIndex}
      plugins={[Zoom, Video]}
      carousel={{
        finite: isSingleImage,
        preload: isSingleImage ? 0 : 2,
      }}
      on={{
        view: onIndexChange
          ? ({ index }: ViewCallbackProps): void => onIndexChange(index)
          : undefined,
      }}
      render={{
        buttonPrev: isSingleImage ? () => null : undefined,
        buttonNext: isSingleImage ? () => null : undefined,
      }}
    />
  );
};

export default ReusableLightbox;
